import { Link } from "react-router-dom";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import ActivationSteps from "../components/ActivationSteps";
import { Check, Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
function DriesFaseAansluiting() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="3-fase aansluiting - Elektraaanleggen.nl"
        description="Upgrade naar een 3-fase aansluiting voor uw zware apparatuur, laadpaal of warmtepomp. Onze experts zorgen voor een professionele installatie."
        schema={generateServiceSchema({
          name: "3-fase aansluiting",
          description:
            "Verhoog de capaciteit van uw elektriciteitsnetwerk met een professionele 3-fase aansluiting voor zwaardere apparatuur zoals laadpalen, warmtepompen en meer.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />
      <Header />
      <HeroSection
        title="3-fase aansluiting"
        description="Upgrade naar een 3-fase aansluiting voor uw zware apparatuur, laadpaal of warmtepomp. Onze experts zorgen voor een professionele installatie."
        imageSrc="/images/mt2.png"
      />
      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              3 fase aansluiting
            </h2>
            <p>
              Gaat u over van een 1-fase aansluiting naar een 3-fase aansluiting
              via uw netbeheerder, of heeft u een volledige 3-fase installatie
              nodig? Bij Elektra Aanleggen staan we klaar om u te helpen met een
              betrouwbare en veilige oplossing, volledig afgestemd op uw wensen.
            </p>
            <br></br>
            <p>
              Wij begrijpen dat dit een grote stap kan zijn, daarom maken we het
              u graag zo eenvoudig mogelijk. Voor deze werkzaamheden kunnen we
              vaak telefonisch al een prijsindicatie geven. Stuur ons gerust een
              paar foto’s van uw meterkast en situatie, en wij kijken direct met
              u mee. Zo weet u precies wat er nodig is en wat u kunt verwachten.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/uitbereiden.jpg"
              />
            </div>
          </div>
        </div>
        <ActivationSteps />
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              3-fase meterkast uitbreiden voor nieuwe of bestaande installaties
            </h2>
            <p>
              Heb je een extra groep nodig voor een laadpaal, warmtepomp,
              inductiekookplaat of andere zware elektrische apparaten? Dan is
              een 3-fase aansluiting essentieel om overbelasting en
              stroomstoringen te voorkomen. Bij Elektra Aanleggen breiden wij
              jouw 3-fase meterkast vakkundig uit of installeren een compleet
              nieuwe krachtstroomaansluiting, afgestemd op jouw energiebehoefte.
            </p>
            <br></br>
            <p>
              Een 3-fase groepenkast biedt meer vermogen en een stabielere
              stroomvoorziening, wat noodzakelijk is voor moderne elektrische
              installaties. Of het nu gaat om een woning of bedrijfspand, wij
              zorgen voor een veilige en efficiënte uitbreiding volgens de
              nieuwste NEN-normen.
            </p>
            <br></br>
            <p>
              Wil je weten of jouw meterkast geschikt is voor een 3-fase
              uitbreiding of heb je advies nodig over het aanleggen van
              krachtstroom? Neem dan contact op met Elektra Aanleggen voor een
              vrijblijvende inspectie en offerte op maat.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/ABB-440x390-3F.png"
              />
            </div>
          </div>
        </div>
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              3-Fasen Aansluiting – Zorgeloos en Veilig Geregeld!
            </h2>
            <p>
              Wil je je aansluitvermogen uitbreiden naar 3 fasen? Dit is
              essentieel als je een elektrische auto, inductiekookplaat of
              warmtepomp gebruikt en een stabiele, krachtige stroomvoorziening
              nodig hebt. De overstap naar een 3-fase groepenkast zorgt ervoor
              dat je meer elektrische apparaten tegelijkertijd kunt gebruiken
              zonder overbelasting.
            </p>
            <br></br>
            <p className="font-semibold">
              Hoe werkt de overstap naar een 3-fasen aansluiting?
            </p>
            <p>
              <br></br>
              <strong>Stap 1:</strong> Voorbereiding groepenkast – Wij bereiden
              uw groepenkast voor op de 3-fasen aansluiting, zodat alles klaar
              is voor de netbeheerder.
            </p>
            <br></br>
            <p>
              <strong>Stap 2:</strong>
              Afspraak maken met de netbeheerder – U plant een afspraak met uw
              netbeheerder voor de definitieve aansluiting. Als de netbeheerder
              hierom vraagt, kunt u een foto van de voorbereide groepenkast
              opsturen ter controle.
            </p>
            <br></br>
            <p>
              <strong>Stap 3:</strong>
              Netbeheerder voltooit de aansluiting – De netbeheerder sluit alle
              3 fasen aan op het hoofdnetwerk en rondt de installatie af.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="perilex aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/Aanvragen-3-Fase-aansluitingen.jpg"
              />
            </div>
          </div>
        </div>
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              De voordelen van een 3-fase aansluiting
            </h2>
            <p>
              Een 3-fase aansluiting biedt meer vermogen, stabiliteit en
              toekomstbestendigheid, vooral als u veel elektrische apparaten
              gebruikt. Dit type aansluiting zorgt ervoor dat u zonder problemen
              meerdere zware apparaten tegelijk kunt gebruiken, zoals een
              inductiekookplaat, laadpaal, warmtepomp of zonnepanelen.
            </p>
            <br></br>
            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Meer stroomcapaciteit zonder overbelasting – U kunt grotere
                  apparaten tegelijkertijd gebruiken zonder dat de stroom
                  uitvalt.
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Betere verdeling van elektriciteit – Uw apparaten werken
                  efficiënter, waardoor ze langer meegaan en storingen worden
                  voorkomen.
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Essentieel voor toekomstig stroomverbruik – Elektrische
                  auto’s, warmtepompen en andere duurzame toepassingen vereisen
                  steeds vaker een 3-fase aansluiting.
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Geschikt voor zonnepanelen – Voorkomt teruglevering problemen
                  en zorgt voor een stabiele energievoorziening.
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Veiliger en efficiënter – Uw elektrische installatie is beter
                  bestand tegen piekbelastingen en voldoet aan de nieuwste
                  normen.
                </span>
              </li>
            </ul>
            <br>
            </br>
            <p>
            Steeds meer huishoudens schakelen over op een 3-fase aansluiting om klaar te zijn voor de toekomst. Wilt u weten of uw woning geschikt is?
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <span className="absolute bg-[#17354A] text-white px-2 py-1 text-xs  rounded-md opacity-20 top-1/4 right-1/3">
                elektraaanleggen.nl
              </span>
              <img
                alt="3-fase aansluiting"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/3fase.png"
              />
            </div>
          </div>
        </div>
      </section>
      <ServicesOverview />
      <FAQ />
      <ServiceHighlights />
      <Reviews />
      <PartnerMarquee />
      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>
      <HelpButton />
      <Footer />
    </div>
  );
}
export default DriesFaseAansluiting;
